module.exports = __webpack_public_path__ + "static/media/24_A.c18ece9c.jpg";